import React from "react";

export default function StoreHealthBars({ data = [], title = "Operations Health", subtitle = "", insights = [] }) {
  return (
    <div
      style={{
        background: "linear-gradient(180deg, rgba(10,24,54,0.96), rgba(5,14,33,0.96))",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 18,
        padding: 16,
        minHeight: 340,
      }}
    >
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: "#fff" }}>{title}</div>
        {subtitle ? <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>{subtitle}</div> : null}
      </div>

      <div style={{ display: "grid", gap: 14 }}>
        {data.map((item, idx) => (
          <div key={item.name || idx}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, marginBottom: 6 }}>
              <div style={{ fontSize: 13, color: "#fff", opacity: 0.92 }}>{item.name}</div>
              <div style={{ fontSize: 12, color: "#47d7f4", fontWeight: 900 }}>{item.value}%</div>
            </div>
            <div style={{ height: 10, borderRadius: 999, background: "rgba(148,163,184,0.18)", overflow: "hidden" }}>
              <div
                style={{
                  height: "100%",
                  width: `${Math.max(0, Math.min(100, Number(item.value || 0)))}%`,
                  borderRadius: 999,
                  background: item.value >= 85 ? "#22c55e" : item.value >= 70 ? "#47d7f4" : "#f59e0b",
                }}
              />
            </div>
            {item.meta ? <div style={{ marginTop: 5, fontSize: 11, opacity: 0.62 }}>{item.meta}</div> : null}
          </div>
        ))}

        {insights.length ? (
          <div
            style={{
              marginTop: 4,
              borderTop: "1px solid rgba(255,255,255,0.06)",
              paddingTop: 12,
              display: "grid",
              gap: 8,
            }}
          >
            {insights.map((text, idx) => (
              <div
                key={idx}
                style={{
                  fontSize: 12,
                  padding: "8px 10px",
                  borderRadius: 12,
                  background: "rgba(255,255,255,0.04)",
                  color: "#d8e4ff",
                }}
              >
                {text}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
